import React, { useEffect, useState } from "react";
import config from "../../utils/Config";
import './report.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Button from '@mui/material/Button';
import MuiCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { toast } from 'react-toastify';
import reportService from "../../features/report/reportService";
import commonService from '../../features/common/commonService';
import authService from "../../features/auth/authService";
import Spinner from "../Layout/Spinner";
import { useNavigate } from 'react-router-dom'
import moment from "moment";
import Tooltip from '@mui/material/Tooltip';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as us from 'underscore';
import _ from 'lodash';

function Report(props) {
  const navigate = useNavigate()
  let [reportOrderData, setReportOrderData] = useState({});
  let [showData, setShowData] = useState(false);
  let [isLoading, setIsLoading] = useState(false);
  let [showPage, setShowPage] = useState(false);
  let [isSaveButtShow, setIsSaveButtShow] = useState(false);
  let [isDistDisable, setIsDistDisable] = useState(false);
  let [isSchoolDisable, setIsSchoolDisable] = useState(false);
  let [isSubDisable, setIsSubDisable] = useState(false);
  let [issubscriptionEndDate, setIssubscriptionEndDate] = useState('');
  let [IssurveyRegSubmit, setIssurveyRegSubmit] = useState(false);
  let [issubscriptionEndDateaction, setIssubscriptionEndDateaction] = useState('');
  let [isChecked, setIsChecked] = useState(false);
  let [dateshow, setdateshow] = useState('');
  const [distName, setDistName] = useState('');
  let [isSaveShowAdmin, setIsSaveShowAdmin] = useState(false);


  useEffect(() => {
    document.title = props.title

    setIsLoading(true)
    reportService.getReportPageDate({ districtId: authService.getDist(),academicyear:localStorage.getItem("academicyear") }).then((response) => {
      setShowData(true);
      setDistName(response.data.distName)
      setReportOrderData(response.data);
      setIssubscriptionEndDate(response.data.subscriptionEndDate)
      setShowPage(true)
      setIsLoading(false)
      setIssubscriptionEndDateaction(response.data.subscriptionEndDateAction)
      setIssurveyRegSubmit(response.data.surveyRegSubmitAction)
      const active_sub_year=['07/26', '07/27'];
      console.log("response.data.subscriptionEndDate", moment(response.data.subscriptionEndDate).format("YYYYMMDD"))
      console.log("response.data.orderReportSubmit", response.data.orderReportSubmit)
      console.log("response.data.subscriptionEndDateAction", response.data.subscriptionEndDateAction)
      console.log("config.SUB_END_DATE", moment(config.SUB_END_DATE).format("YYYYMMDD"))
      console.log("moment(response.data.subscriptionEndDate)==(moment(config.SUB_END_DATE))",moment(response.data.subscriptionEndDate).isSame(moment(config.SUB_END_DATE)))
      // 1)order report saved but not submitted
      if(!response.data.orderReportSubmit && moment(response.data.subscriptionEndDate).isSame(moment(config.SUB_END_DATE)) && response.data.subscriptionEndDateAction == 'dashboard subscribed'){
        console.log("order report saved but not submitted")
        setIsSubDisable(false);
        setIsChecked(true);
        setdateshow(convertDate(config.SUB_END_DATE))
      }
      // 2)order report ordered in current year
      else if(response.data.orderReportSubmit && moment(response.data.subscriptionEndDate).isSame(moment(config.SUB_END_DATE)) && response.data.subscriptionEndDateAction == 'dashboard subscribed'){
        console.log("order report ordered in current year")
        setIsSubDisable(true);
        setIsChecked(true);
        setdateshow(convertDate(config.SUB_END_DATE))
        setIsDistDisable(true)
        setIsSchoolDisable(true)
      }
      // 3) order report submitted in historical year
      else if(active_sub_year.includes(convertDate(response.data.subscriptionEndDate))){
        console.log("order report submitted in historical year")
        setIsSubDisable(true);
        setIsChecked(true);
        setdateshow(convertDate(response.data.subscriptionEndDate))
        if(response.data.orderReportSubmit){
          setIsDistDisable(true)
          setIsSchoolDisable(true)
        }
        
      }
      // 4)order report subscription expired and order reported in current without renewal subscription
      else if(!active_sub_year.includes(convertDate(response.data.subscriptionEndDate)) && response.data.orderReportSubmit){
        console.log("order report subscription expired and order reported in current without renewal subscription")
        setIsSubDisable(true);
        setIsChecked(false);
        setdateshow('')
        setIsDistDisable(true)
        setIsSchoolDisable(true)


      }
      // district is deleted and readded in the same year
       else if(response.data.subscriptionEndDate==null && !response.data.orderReportSubmit &&  response.data.subscriptionEndDateAction == 'dashboard subscribed'){
        console.log("district is deleted and readded in the same year")
        setIsSubDisable(false);
        setIsChecked(false);
        setdateshow('')
      }
      // 5) order report supscription expired and order report not submitted in current year
      else if(!active_sub_year.includes(convertDate(response.data.subscriptionEndDate)) && !response.data.orderReportSubmit && response.data.subscriptionEndDateAction != 'dashboard remove subscribtion' && convertDate(response.data.subscriptionEndDateAt)!='07/25'){
        console.log("order report supscription expired and order report not submitted in current year")
        setIsSubDisable(false);
        setIsChecked(false);
        setdateshow('')
      }
      // 6) order report cancelled in current year and reorder order report without selecting the order report
      else if(response.data.subscriptionEndDateAction === 'dashboard remove subscribtion' && response.data.orderReportSubmit){
        console.log("order report cancelled in current year and reorder order report without selecting the order report")
        setIsSubDisable(true);
        setIsChecked(false);
        setdateshow('')
        setIsDistDisable(true)
        setIsSchoolDisable(true)
      }
      // 7) order report cancelled and didnt reorder again
      else if(response.data.subscriptionEndDateAction === 'dashboard remove subscribtion' && !response.data.orderReportSubmit){
        console.log("order report cancelled and didnt reorder again")
        setIsSubDisable(false);
        setIsChecked(true);
        setdateshow(convertDate(config.SUB_END_DATE))
      }
      // 8) subscriptionenddate is null and order report not submitted
      else if(!response.data.subscriptionEndDate && !response.data.orderReportSubmit){
        console.log("subscriptionenddate is null and order report not submitted")
          setIsSubDisable(false);
          setIsChecked(false);
          setdateshow('');
      }
      // 9) subscriptionenddate is null and order report submitted
      else if(!response.data.subscriptionEndDate && response.data.orderReportSubmit){
        console.log("subscriptionenddate is null and order report submitted")
        setIsSubDisable(true);
        setIsChecked(false);
        setdateshow('')
        setIsDistDisable(true)
        setIsSchoolDisable(true)
      }
      else{
        console.log("default case")
          setIsSubDisable(false);
          setIsChecked(false);
          setdateshow('')
      }
      // const excludedDates = ['07/24'];
      // if(response.data.subscriptionEndDateAction==='dashboard remove subscribtion' && !response.data.orderReportSubmit){
      //   setdateshow(convertDate(config.SUB_END_DATE))
      //   setIsChecked(true);
      // }
      // else if(response.data.subscriptionEndDate && !excludedDates.includes(convertDate(response.data.subscriptionEndDate))){
      //   setdateshow(convertDate(response.data.subscriptionEndDate))
      //   setIsChecked(true);
      //   }
    }).catch(err => {
      setShowData(false);
      toast.error(err.message ? err.message : "Unable to fetch enrollment data.");
      setIsLoading(false);
    })
  }, []);

  useEffect(() => {
    if (reportOrderData.orderReportSubmit && localStorage.getItem('role') == 'dc') {
      toast.info('Report Order Form has been submitted. To update your report order, please contact your CalSCHLS Technical Advisor.');
    }
    if(reportOrderData.orderReportSubmit){
      setIsSaveShowAdmin(true)
    }
    else{
      setIsSaveButtShow(true)
      setIsSaveShowAdmin(false)
    }
    // if (reportOrderData.orderReportSubmit) {
    //   setIsDistDisable(true)
    //   setIsSchoolDisable(true)
    //   setIsSubDisable(true)
    //   setIsSaveShowAdmin(true)

    // } else {
    //   setIsDistDisable(false)
    //   setIsSchoolDisable(false)
    //   setIsSaveButtShow(true)
    //   setIsSaveShowAdmin(false)
    //   const excludedDates = ['07/27'];
    //   if (reportOrderData.subscriptionEndDate) {
    //     if (moment(issubscriptionEndDate).format("YYYYMMDD") === moment(config.LAST_YEAR_END_DATE).format("YYYYMMDD")) {
    //       setIsSubDisable(false)
    //     }
    //     else if (issubscriptionEndDate==null){
    //       setIsSubDisable(false)
    //     }
    //     else if(!reportOrderData.orderReportSubmit && moment(config.LAST_YEAR_END_DATE).format("YYYY")===moment(reportOrderData.subscriptionEndtDate).format("YYYY"))
    //     {
    //       setIsSubDisable(false)
    //     }
    //     else if(moment(config.LAST_YEAR_END_DATE).format("YYYYMMDD")!=moment(issubscriptionEndDate).format("YYYYMMDD"))
    //     {
    //       if(!reportOrderData.orderReportSubmit && moment(issubscriptionEndDate).format("YYYYMMDD")===(moment(config.SUB_END_DATE).format("YYYYMMDD"))){
    //         setIsSubDisable(false)
    //       }
    //       else{
    //         setIsSubDisable(true)
    //       }          
    //     }

    //   } else {
    //     setIsSubDisable(false)
    //   }
    // }

  }, [reportOrderData]);

  const convertDate = (dateStr) => {
    return moment(dateStr).format('MM/YY');
  }

  const handleSubscription = (event) => {
    setIsChecked(event.target.checked);
    if (dateshow==''){
      setdateshow(convertDate(config.SUB_END_DATE))
    }
    if(isChecked==true && dateshow==convertDate(config.SUB_END_DATE))
    {
      setdateshow("")
    }
    if (!reportOrderData.subscriptionEndDate) {
      setReportOrderData((prev) => {
        let helper = { ...prev };
        helper.subscriptionEndDate = config.SUB_END_DATE;
        return helper;
      })
    } else {
      setReportOrderData((prev) => {
        let helper = { ...prev };
        helper.subscriptionEndDate = '';
        return helper;
      })
      // if (
      //   moment(enddate).format("YYYYMMDD") ===
      //   moment(subEndDate).format("YYYYMMDD")
      // ) {
      //   console.log("inside if of else")
      //   setReportOrderData((prev) => {
      //     let helper = { ...prev };
      //     helper.subscriptionEndDate = '';
      //     return helper;
      //   })
      // }
    }

  }


  const renderDataDashboardReports = () => {
    // const excludedDates = ['07/24'];
    // let datetoshow=""
    // // let checked;
    // if(reportOrderData.subscriptionEndDateAction==="dashboard remove subscribtion"){
    //   datetoshow=convertDate(config.SUB_END_DATE)
    //   // setIsChecked(!!datetoshow);
    // }
    // else{
    //   datetoshow=convertDate(reportOrderData.subscriptionEndDate)
    //   // setIsChecked(!!datetoshow);
    // }
    // else if(reportOrderData.subscriptionEndDate && !excludedDates.includes(convertDate(reportOrderData.subscriptionEndDate))){
    //   datetoshow=convertDate(reportOrderData.subscriptionEndDate)
    //   checked=true
    // }
    // else{
    //   checked=false
    // }


    //  datetoshow=convertDate(reportOrderData.subscriptionEndDate)
    // if(convertDate(reportOrderData.subscriptionEndDate)==convertDate(config.LAST_YEAR_END_DATE)){
    //   datetoshow=""
    // }
    return (
      <Accordion>
        <AccordionSummary
          className='accordionSummary'
          expandIcon={<ExpandMoreIcon />}
          style={{ flexDirection: 'row-reverse' }}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Table className='accordionHeader'>
            <TableRow >
              <TableCell className='report_schoolHeader'>
                <img className="report_tickImage" src={require(`../../assets/images/dbSubscription_new.png`)} alt="Image for FAQ" />
              </TableCell>
              <TableCell className='report_schoolHeaderPht report_hdrImageText'>District Data Dashboard</TableCell>
            </TableRow>
          </Table>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer>
          
          { localStorage.getItem("academicyear") === 'currentyear' ?
          <Table className="report_accordionBody">
            <TableBody>
              <TableRow className={isDistDisable ? 'disableRadio report_highlightColor' : 'report_datadashboard_space report_highlightColor'}>
                <TableCell className='report_schoolDashboard report_schoolDashHt'>Order Data Dashboard</TableCell>
      
                {/* <TableCell className='report_schoolSubHeader_db' sx={{ 'paddingLeft': '10px !important' }}></TableCell>
                <TableCell className='report_schoolSubHeader_db'></TableCell> */}
              </TableRow>

              <TableRow className={isDistDisable ? 'disableRadio report_datadashboard_space' : 'report_datadashboard_space'}>
                <div id="dashboardAccordionTable">
                  <div style={{ 'flex': '98%', 'marginTop':'10px' }} className={isDistDisable ? 'disableRadio report_schoolBody' : 'report_schoolBody'}>
                    <Tooltip title="Data Dashboard" placement="top-start">
                      <span>Data Dashboard</span>
                    </Tooltip>
                  </div>
                  <div className='report_schoolBody' style={{ 'flex': '35%' }}>
                    <MuiCheckbox
                      className='resport_dashboardCheckbox'
                      icon={<RadioButtonUncheckedIcon />}
                      checkedIcon={<CheckCircleIcon />}
                      iconstyle={{ fill: '#003c68' }}
                      disabled={isSubDisable || localStorage.getItem("selectedYear") ? true : false}
                      checked={isChecked}
                      onChange={(event) =>
                        handleSubscription(event)
                      }
                      sx={{
                        color: localStorage.getItem("selectedYear") ? '#b4b0b0d6' : '#003c68',
                        '&.Mui-checked': {
                          color: isSubDisable || localStorage.getItem("selectedYear") ? '#6D6D6D' : '#18A558',
                          transform: "scale(0.9)"
                        },
                      }}
                    />
                   {dateshow ? ( <span style={{ color: '#000' }}> Exp {dateshow} </span> ) : ( <span> </span> )}
                  </div>
                </div>
              </TableRow>
            </TableBody></Table> : 
             <div className="noShool">Contact your Technical Advisor for information on the Data Dashboard subscription.</div>
            
            }
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    );
  };

  const handleDistRepChange = (event, surveyId, reportTypeId) => {
    setReportOrderData((prev) => {
      let helper = { ...prev };
      if (helper.distReportData) {
        let surveyObj = helper.distReportData.find((v1, k1) => {
          return v1.surveyId == surveyId
        });
        let reportObj = surveyObj.distReportData.find((v1, k1) => {
          return v1.reportTypeId == reportTypeId
        })
        reportObj.value = event.target.checked ? 1 : 0;
      }
      return helper;
    })
  }


  const handleDistRepChangeAll = (event, reportTypeId) => {
    setReportOrderData((prev) => {
      let helper = { ...prev };
      if (helper.distReportData) {
        helper.distReportData.map((val, key) => {
          if (val.disable == false) {
            let reportObj = val.distReportData.find((v1, k1) => {
              return v1.reportTypeId == reportTypeId
            })
            reportObj.value = event.target.checked ? 1 : 0;
          }

        })
      }
      return helper;
    })
  }

  const handleDistRepChangeAllInit = (reportTypeId) => {
    let count = 0;
    reportOrderData.distReportData.map((val, key) => {
      let reportObj = val.distReportData.find((v1, k1) => {
        return v1.reportTypeId == reportTypeId
      })
      if (reportObj.value == 1)
        count += 1
    });

    let distSelLength = reportOrderData.distReportData.filter((val, key) => {
      return val.disable == false
    })

    if (distSelLength.length == 0) {
      return false
    }

    return distSelLength.length == count ? true : false
  }

  const renderDistrictReports = () => {
    return (
      <Accordion>
        <AccordionSummary
          className='accordionSummary'
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          style={{ flexDirection: 'row-reverse' }}
          id="panel1a-header"
        >
          <Table className='accordionHeader'>
            <TableRow >
              <TableCell className='report_schoolHeader'>
                <img className="report_tickImage" src={require(`../../assets/images/dr_new.png`)} alt="Image for FAQ" />
              </TableCell>
              <TableCell className='report_schoolHeader report_hdrImageText'>District Raw Datasets</TableCell>
              <TableCell className='report_schoolHeaderPht'></TableCell>
            </TableRow>
          </Table>
        </AccordionSummary>
        <AccordionDetails>
          {authService.getRole() == 'dc' ?
            <div className="noShool">To place an order for a District Raw Dataset, please contact your CalSCHLS Technical Advisor.</div>
            :
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className='report_schoolHeader'></TableCell>
                    {reportOrderData.distReportData[0].distReportData.map((data, key) => (
                      <TableCell className='report_schoolHeader' align='center' key={key}>
                        <Tooltip className='report_districtrawdataset' title={(data.reportTypeName).replace("*", " ")} placement="top-start">
                          <span>{(data.reportTypeName).replace("*", " ")}</span>
                        </Tooltip>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow className={isDistDisable && !isSaveShowAdmin ? 'disableRadio report_highlightColor' : 'report_datadashboard_space report_highlightColor'}>
                    <TableCell className='report_schoolDashboard1 report_schoolDashHt report_schoolSubHeader_db' sx={{ width: '30px' }}>Check / Un-Check for entire column selection</TableCell>
                    {reportOrderData.distReportData[0].distReportData.map((data, key) => (
                      <TableCell className='report_schoolDashboard1 report_schoolDashCk'>
                        <FormControlLabel
                          control={
                            <MuiCheckbox
                              className="radioButtonSize"
                              icon={<RadioButtonUncheckedIcon
                                // style={{ color: '#ffffff' }} />}
                              style={{ color: isDistDisable || isSaveShowAdmin ? '#b4b0b0d6' : '#ffffff' }} />}
                              checkedIcon={<CheckCircleIcon />}
                              // disabled={isDistDisable && !isSaveShowAdmin ? true : false}
                              disabled={(isDistDisable && !isSaveShowAdmin) || localStorage.getItem('academicyear') !== 'currentyear'}
                              iconstyle={{ fill: '#ffffff' }}
                              checked={handleDistRepChangeAllInit(data.reportTypeId)}
                              onChange={(event) =>
                                handleDistRepChangeAll(event, data.reportTypeId)
                              }
                              sx={{
                                color: localStorage.getItem('academicyear') !== 'currentyear' ? '#b4b0b0d6' : '#003c68',
                                '&.Mui-checked': {
                                  // color: isDistDisable && !isSaveShowAdmin ? '#b4b0b0d6' : '#18A558',
                                  color: isDistDisable || isSaveShowAdmin || localStorage.getItem('academicyear') !== 'currentyear' ? '#b4b0b0d6' : '#18A558',
                                  transform: "scale(0.9)"
                                },
                              }}
                            />
                          }
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                  {reportOrderData.distReportData.map((data, key) => (
                    <TableRow key={key} className={isDistDisable && !isSaveShowAdmin ? 'disableRadio' : 'report_datadashboard_space'}>
                      <TableCell className='report_schoolBody report_imageIconWidth'>
                        <img className="report_distReportImg" src={require(`../../assets/images/` + data.shortCode + `.png`)} alt="Image for FAQ" />
                        <span className='report_schoolHeaderImage '>{data.surveyName}</span></TableCell>


                      {data.distReportData.map((innerData, innerKey) => (
                        <TableCell className='report_schoolDashboard1 report_schoolDashCk'>

                          <FormControlLabel
                            control={
                              <MuiCheckbox
                                icon={<RadioButtonUncheckedIcon />}
                                checkedIcon={<CheckCircleIcon />}
                                checked={innerData.value == '1' ? true : false}
                                disabled={( isDistDisable && !isSaveShowAdmin) || data.disable === true || localStorage.getItem('academicyear') !== 'currentyear' }
                                onChange={(event) =>
                                  handleDistRepChange(event, data.surveyId, innerData.reportTypeId)
                                }
                                iconstyle={{ fill: '#003c68' }}
                                sx={{
                                  // color: '#003c68',
                                  color: isDistDisable || isSaveShowAdmin || localStorage.getItem('academicyear') !== 'currentyear' ? '#b4b0b0d6' : '#003c68',
                                  '&.Mui-checked': {
                                    // color: isDistDisable && !isSaveShowAdmin ? '#b4b0b0d6' : '#18A558',
                                    color: isDistDisable || isSaveShowAdmin  || localStorage.getItem('academicyear') !== 'currentyear' ? '#b4b0b0d6' : '#18A558',
                                    transform: "scale(0.9)"
                                  },
                                }}
                              />
                            }
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}

                </TableBody>
              </Table>
            </TableContainer>
          }

        </AccordionDetails>
      </Accordion>
    );
  };


  const handleSchoolRepChange = (event, surveyId, schoolId, reportId) => {
    setReportOrderData((prev) => {
      let helper = { ...prev };
      if (helper.schoolReportData) {
        let surveyObj = helper.schoolReportData.find((v1, k1) => {
          return v1._id == surveyId
        });

        let schoolObj = surveyObj.schoolRepDataArr.find((v1, k1) => {
          return v1.schoolId == schoolId
        });


        let reportObj = schoolObj.reportSchoolData.find((v1, k1) => {
          return v1.reportId == reportId
        })
        reportObj.value = event.target.checked ? 1 : 0;
      }
      return helper;
    })
  }

  const handleSchoolRepChangeAllInit = (surveyId, reportId) => {
    let count = 0;

    let surveyObj = reportOrderData.schoolReportData.find((v1, k1) => {
      return v1._id == surveyId
    });

    surveyObj.schoolRepDataArr.map((val, key) => {
      let reportObj = val.reportSchoolData.find((v1, k1) => {
        return v1.reportId == reportId
      })
      if (reportObj.value == 1)
        count += 1
    });

    return surveyObj.schoolRepDataArr.length == count ? true : false

  }

  const handleSchoolRepChangeAll = (event, surveyId, reportId) => {

    setReportOrderData((prev) => {
      let helper = { ...prev };
      if (helper.schoolReportData) {
        let surveyObj = helper.schoolReportData.find((v1, k1) => {
          return v1._id == surveyId
        });

        for (let schoolItem of surveyObj.schoolRepDataArr) {
          let reportObj = schoolItem.reportSchoolData.find((v1, k1) => {
            return v1.reportId == reportId
          })
          reportObj.value = event.target.checked ? 1 : 0;
        }
      }
      return helper;
    })

  }

  const renderSchoolReports = () => {
    return reportOrderData.schoolReportData.map((survey) => (
      <Accordion key={survey._id}>
        <AccordionSummary
          className={survey.schoolRepDataArr.length == 0 ? 'accordionSummaryDisable' : 'accordionSummary'}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{ flexDirection: 'row-reverse' }}
        >
          <Table className='accordionHeader'>
            <TableRow>
              <TableCell className='report_schoolHeader'>
                <img className="report_tickImage" src={require(`../../assets/images/${survey.shortCode}.png`)} alt="Image for FAQ" />
              </TableCell>
              <TableCell
                className='report_schoolHeader report_hdrImageText'
                sx={survey.schoolRepDataArr.length == 0 ? { color: '#8f9597 !important' } : { color: '#003c68 !important' }}
              >{survey.name} Reports</TableCell>
              <TableCell className='report_schoolHeaderPht'></TableCell>
            </TableRow>
          </Table>
        </AccordionSummary>
        <AccordionDetails>
          {survey.schoolRepDataArr.length == 0 ?
            <div className="noShool">No schools are registered for this survey.</div>
            :
            <TableContainer>
              <Table className="report_accordionBody">
                <TableHead>
                  <TableRow>
                    <TableCell className='report_schoolHeader'>School Name</TableCell>
                    <TableCell className='report_schoolHeader report_schoolIDHead'>School ID</TableCell>

                    {survey.schoolRepDataArr[0].reportSchoolData.map((reportData) => (
                      <TableCell className='report_schoolHeader'>

                        <Tooltip title={(reportData.reportName).replace("*", " ")} placement="top-start">
                          <span>{(reportData.reportName).replace("*", " ")}</span>
                        </Tooltip>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow className={isDistDisable ? 'disableRadio report_highlightColor report_datadashboard_space' : 'report_datadashboard_space report_highlightColor'}>
                    <TableCell className='report_schoolDashboard report_schoolDashHt' colSpan={2}>Check / Un-Check for entire column selection</TableCell>

                    {survey.schoolRepDataArr[0].reportSchoolData.map((reportData) => (
                      <TableCell className='report_schoolDashboard1'>
                        <FormControlLabel
                          control={
                            <MuiCheckbox
                              icon={<RadioButtonUncheckedIcon
                                style={{ color: '#ffffff' }} />}
                              checkedIcon={<CheckCircleIcon />}
                              iconstyle={{ fill: '#003c68' }}xx
                              ref={el => {
                                if (el) {
                                  el.style.setProperty('padding-left', '15px', 'important'); //old: 9px
                                }
                              }}
                              sx={{
                                color: localStorage.getItem('academicyear') !== 'currentyear' ? '#b4b0b0d6': '#003c68',
                                '&.Mui-checked': {
                                  color: isSchoolDisable || localStorage.getItem('academicyear') !== 'currentyear'? '#b4b0b0d6' : '#18A558',
                                  transform: "scale(0.9)"
                                },
                              }}
                              disabled={isSchoolDisable || localStorage.getItem('academicyear') !== 'currentyear'? true : false}
                              checked={handleSchoolRepChangeAllInit(survey._id, reportData.reportId)}
                              onChange={(event) =>
                                handleSchoolRepChangeAll(event, survey._id, reportData.reportId)
                              }
                            />
                          }
                        />
                      </TableCell>
                    ))}

                  </TableRow>
                  {survey.schoolRepDataArr.map((school) => (
                    <TableRow key={school.schoolId} className={isDistDisable ? 'disableRadio report_datadashboard_space' : 'report_datadashboard_space'}>
                      <TableCell className='report_schoolBody report_schoolNameCell'>{school.name}</TableCell>
                      <TableCell className='report_schoolBody'>{school.ncesId}</TableCell>
                      {school.reportSchoolData.map((reportData) => (
                        <TableCell className='report_schoolBody'>
                          <FormControlLabel
                            control={
                              <MuiCheckbox
                                icon={<RadioButtonUncheckedIcon />}
                                checkedIcon={<CheckCircleIcon />}
                                iconstyle={{ fill: '#003c68' }}
                                sx={{
                                  color: localStorage.getItem('academicyear') !== 'currentyear' ? '#b4b0b0d6' : '#003c68',
                                  '&.Mui-checked': {
                                    color: isSchoolDisable || localStorage.getItem('academicyear') !== 'currentyear' ? '#b4b0b0d6' : '#18A558',
                                    transform: "scale(0.9)"
                                  },
                                }}
                                checked={reportData.value == '1' ? true : false}
                                onChange={(event) =>
                                  handleSchoolRepChange(event, survey._id, school.schoolId, reportData.reportId)
                                }
                                disabled={isSchoolDisable || localStorage.getItem('academicyear') !== 'currentyear'? true : false}

                              />
                            }
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          }
        </AccordionDetails>
      </Accordion>
    ));
  };

  let saveReport = (orderStage) => {
    // console.log(orderStage)

    let inputData = { ...reportOrderData };
    if(issubscriptionEndDateaction!='dashboard subscribed' & IssurveyRegSubmit!="surveyregsubmited" & IssurveyRegSubmit==="yes_TO_no" & (inputData.subscriptionEndDate===null || inputData.subscriptionEndDate==="") & !isChecked){
      toast.error("Please select order Data Dashboard");
    }
    else{
      // if(dateshow==='07/27'){
      console.log("isChecked",isChecked)
      if(isChecked){
        inputData.subscriptionEndDate=config.SUB_END_DATE
        console.log("opps button is checked",config.SUB_END_DATE)
      }
      else{
        console.log("button is unchecked")
        inputData.subscriptionEndDate=null
      }
    let finalInputData = {
      districtId: authService.getDist(),
      removeSubscription: inputData.subscriptionEndDate ? false : true,
      subscriptionEndDate: inputData.subscriptionEndDate ? inputData.subscriptionEndDate : null,
      distReportData: inputData.distReportData.filter((val, key) => {
        return val.disable == false
      }),
      schoolReportData: inputData.schoolReportData.filter((val, key) => {
        return val.disable == false
      })
    }

    setIsLoading(true);
    reportService.saveReportPageData(finalInputData).then((result) => {
      setIsSaveButtShow(false)
      setIsDistDisable(true)
      setIsSchoolDisable(true)
      setIsSubDisable(true);
      if(orderStage == 'beforeSubmit'){
        toast.success("Report Order Form successfully updated. CalSCHLS will not receive your order until the SUBMIT ORDER  button is clicked.");
        // setIsSaveShowAdmin(false)
        setIsSaveShowAdmin(true)

      } else {
        toast.success("Report Order Form successfully updated.");
        setIsSaveShowAdmin(true)

      }
      
      setIsLoading(false);
    }).catch((err) => {
      toast.error(err.message ? err.message : '');
      setIsLoading(false);
      setIsSaveShowAdmin(false)

    })


  }
  }
  let backClick = () => {
    setIsSaveButtShow(true)
    setIsDistDisable(false)
    setIsSchoolDisable(false)
    setIsSubDisable(false);
    setIsSaveShowAdmin(false)


  }
  let sumbitOrder = () => {

    setIsLoading(true);
    reportService.submitReportPageData({ districtId: authService.getDist(), userId: authService.getUserId(), academicyear:localStorage.getItem("academicyear") }).then((result) => {
      setIsDistDisable(true)
      setIsSchoolDisable(true);
      setIsSubDisable(true);
      setIsSaveShowAdmin(true)


      setReportOrderData((prev) => {
        let helper = { ...prev };
        helper.orderReportSubmit = true;
        return helper;
      });
      setIsLoading(false);
      toast.success("Report Order Form successfully submitted.")

    }).catch(err => {
      toast.error(err.message ? err.message : '');
      setIsLoading(false);
    })
  }

  const goToCostEstimate = () => {
    navigate('/costestimate')
  }

  const goToManageDashboard = () => {
    navigate('/dashboard')
  }

  let urlDistName = (distName.replace("%20", " ")).replace(/ /g, '');

  //New Code Added **START
  let CombinedSchoolrptdata = [];
  let CombinedSchoolrptdataFinal = [];
  let modifiedData = _.map(reportOrderData.schoolReportData, (value, key, object) => {
    _.map(value["schoolRepDataArr"], (value1, key1, object1) => {
      value1["ParentName"] = value["name"];
      CombinedSchoolrptdata.push(value1);
    });
  });
  _.map(CombinedSchoolrptdata, (value, key, object) => {
    value["P1"] = 0;
    value["P2"] = 0;
    value["P3"] = 0;
    value["P4"] = 0;
    let temp = _.filter(CombinedSchoolrptdata, {
      name: value.name
    });
    let mainData = _.filter(temp, (value, key, object) => {
      return (_.find(value["reportSchoolData"], { "value": 1 }));
    });
    if (mainData.length > 0) {
      let temp1 = {};
      _.map(mainData, (v, k) => {
        if (k == 0) {
          temp1 = _.cloneDeep(v);
        }
        switch (v["ParentName"]) {
          case 'Elementary School':
            temp1["P1"] = 1;
            break;
          case 'Secondary School':
            temp1["P2"] = 1;
            break;
          case 'Staff School':
            temp1["P3"] = 1;
            break;
          case 'Parent School':
            temp1["P4"] = 1;
            break;
          default:
            break;
        }
        CombinedSchoolrptdataFinal.push(temp1);
      });
    } else {
      CombinedSchoolrptdataFinal = _.concat(CombinedSchoolrptdataFinal, temp);
    }
  });
  CombinedSchoolrptdataFinal = _.uniqBy(CombinedSchoolrptdataFinal, "schoolId");

  const onreportpdfdownload =  async () => {
    const margin = 6;  // Set a consistent margin for the entire document
    let chkImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAyCAYAAADsg90UAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAACQVJREFUaIHdWl1QU9kd/yU3l6QqakYScLaACoiCgorIx2ICAaq4LqPsshqn04d2DLMPTh87nW7HvrSP2+3oVKetWzvdD91uUXYcdyFdHd3ZbbstZVdZEBfUGJMIhCQk5Cbk454+kISbkNzcfOAu+7uTSXLvPfec3+/8P8459wDfNeigEvWI+vFj5Aq5Xbzc7Xmm0EHVUN6gf+3Ya2158rwbQkSgnkW7ngl0UNWX1+uPq47Ta1atEe8o3qH4yvjVQWY7cwlD8CUq9t0QQAfVvq379K/sf4UWiUUiQghkUhlVWVypuGu82+Hd7n03kQgrXwAdVLVbayPkWbAgoUMmlVE7i3Yqhg3DHd6K+CKsbAF0UO3dulff/Xz3Qs8j5iAEshwZVVFcoRh5PNLhrfVewueY5z5i5Qqgg2pv2V591/NdtIhaMHtCCFjCIvI7dMikMqqisEIxMjFyMFaElSmADqqashr90cajC+SxQDbc67EHCxZSqZSqKKpQjD4YjbKElSeADqo9pXv0RxqPRPU8t9e5LsD9SHOk1Lbvb8u79/BeRATRN80nJeig2l26W9/Z0EmLKbEIAAjIwrXIF1lSjJDFcwQEDpfDf/HDi3ddxNWycixAB9Wukl36zobOSKqL2/Pcc+F4EBMYpTlSqrywPG94fNgk+aZ5CYIOquqSav0L9S/QrJiNstpw7/L1fLxrT0xPznnOeM59+wXQQVVVUqU/VHeIJiIiIixJmWysC0wMTJzp+03fTwHg2x0DdFBVlVbpO2o7aBElirQ1lhAXfNcAYEI/cf7Kr6+8Gv4vXIBu5ECOtfgDrILLZIKTUO8s3TlwsPYgDXF0O7nEuIQTXQufM9w2vHnlV1d+wr1fmADdyJEVyK7mrsrdNm2dbsAFTKbCJWWchLqypHLgwN4DkTwPIG6kD/+OFSL2mvFT41+vnr76o9h7kgsQIn+i7UTb2u+tFb398dvGZRUhRL69pj3K7AHhZGPPmf9pvtT7y94TwFKf4BcgRF7brm1TrlfSAOD2uAOXb1xeHhFOQl1eUj5woOYADYrTtpieT8UFpj+f/vv7v3i/G3HIA3wCdCNHtlHWd0xzrDVfnk9z/YnxMoH3br5ntFqt2RPhJNRbt2wdaK9pp8VisSiemafqAlNDU329P+vtAsAmqjb+QChE/uWWl1uV65V07EBDQknEJc+V5BqmDN3MNuYShuBOlW8UTkJdtrlsoG1PGw0xosf2WDqgiZrwhH6H72cJC5awmP5i+kPbddtRg8EQ5Kt6qQWEyL/U8lKrct2C2QNxzI8AjIcJ9N7uNc7MzKRvCSHymj0aWiTmpDqeaB6V3uK4h23Y9g/ju8ZDg4OD/mTVRwvQjRxZvuyDLk2XRrleSfM1Igy3xx3ou92Xngg9aC7bVNbfvKs5EvCEBDg+97CP2m8O/364Y3x8PGrenwiLApyCVEZkfUc0RzSKdQo6tjHxLCAMt9ftv/bJtScpidCD5tLi0n7VLlX8no/q5BgLSNAux33HJ3d+e+cHBoPBK6gNCAsQIt/Z0qlRrFPQcZVOEm2ZecZ//fZ1o81ua0wqQg+aS4pK+puqm2gxFRPwUhzbh8+5vnb9y/SWqXVwcJBJTnsRIpyCVAZZ32H14cWe51Oax0Td827/R7c/Mtrt9sQi9KB5S9GW/v3V+yMjvGRRPVkWmHsw95+J8xOakZGRuVTIAwCFarxaX11/qrigmIq3ppboYAm75JyEklBFzxWtMU+Zu73bvZeXZIcQ+caqRhoURHyrOIlWdmLrdhlcQ/d+d08zNjbmSpX8ggAv4r/mr81b8jfkV65evVrMTTNRqYhbeUzjIvcTFhJKQhVuLFxjtsaI0IPmzYWb+xuqGmgiJqJE83UhdYf/uw3uO6Y/mVpGR0dn0yEPhGPAaYglFsnF9qZ27UbFRgnfiIvXRDn3enwe/43PbhgddkcjJNi+qXBTf/3O+sjqbdJnxQTBIAnC7XdjzjcHT8ADxwPHkO2iTTNrmHWkS35RAI4IbU1t2vy8fElSAfgCV+iL8TH+m5/dtMjl8oK6HXVLUh2fACxh4fQ54Zx3wulzgvEzkWt+o/+LybOTGszCngn5aAE4IjQ3NmsLFAUSvjQoNEjNz88HaAlNcae0ifJ6gA1gxjsDu9eO2flZsGTpCDZgDgxb37C2YC470/KlI8GQCOpGtVaZp4ysGKViAUJMOvwdZIOY8c7AyljhmHcscScuAk8Do/bX7c1wYyolljyIPxkKidDU0KRVblBGuQPfaCxuDk+QupzzTljcFsx4ZhAkvMN1AEBwMnjf+bpTDQZPhZITgsSzwdMQUxbqYkN9g7Ygb9EdhIwREonDEhZTzBRMcya4/cLnT0FrcMJ91q2GDSbBhQSCfz0gJEJdXZ02f0MoMPKMxhK5h4/1weQywTxnhp9NOj+JArERA3OGUcGOxykVFIjkK0IhEWr31WqVG5SSVCzAG/DC4DTA4rbEDWjJwDpYo/8NvxqzeJhyYYEQtiYYEqFmX41WIVckTZHegBePnI9gcpl4gxovZmEOnAuoMY3x9B4gDMJXhUMi7K7drVXIFZJ4fu4L+vBw9iGMLmNaPR6BC5PkLFFjBmPpP0QYhL8auwVCDpO+ybHJ0lx5buUq2arI/iKWsDDMGvDl1JeweWwLFkGQ3mcO0zgPDaYxmiWOvEjt3WBIhKn7U6W58tzK1dLVYitjxdDTIVjmLGBZNn3iC+RtuIBWWDCcLYLJkN6boZA7yDfLj1thpZMXEAAPHPgjWmHB/7LyPIFI7+1wyBKYx0wJpKgABSqjnvfAiT+jHWYMZkooVaT/evwWCF7EB7AgMxG8mMObOAAT/p0ZlfSQ2f6AsAhPOSKkAh8Y/AUdMOHTjNqRATLfIMEVIScFS/DBg7dwGI9xK+M2ZIDs7BAJizAp0BKCmMc76MQjfJyV+jNA9rbIcEWgUQFxAkvww4dL6MJD9Get7gyQ3T1CYRGmEogQhB+96MY4rmW13gyQ/U1SYRGmOSIAQBABXIEWY7ia9TozwPLsEosVARChDz/EGP62LPVlgOXdI3QaYphxARI8xTn8fFnrShP/B0iUY6sVdQpDAAAAAElFTkSuQmCC";
    let hdrImage = "data:image/png;base64,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";
    //  let hdrImage = './assets/images/header11.png';
    // let chkImage ='./assets/images/header12.png';
    let doc = new jsPDF('p');

    // Header Image
    doc.addImage(hdrImage, 'PNG', margin, margin, 30, 8, 'logo');
    doc.setFontSize(14);
    doc.setTextColor(143, 149, 151);
    doc.text(margin, margin + 14, 'CalSCHLS Coordinator Portal');

    // Order Confirmation Text
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(margin, margin + 24, 'ORDER CONFIRMATION FOR OPTIONAL REPORTS');

    // District Name
    doc.setFontSize(12);
    doc.setTextColor(248, 119, 28);
    doc.text(margin, margin + 34, distName);

    // District Data
    doc.setFontSize(10);
    doc.setTextColor(143, 149, 151);
    doc.text(margin, margin + 44, 'DISTRICT DATA');
    doc.setTextColor(0, 60, 104);

    // Table for District Data
    doc.autoTable({
        startY: margin + 47,
        margin: { left: margin, right: margin },  // Uniform margin for the table
        tableLineColor: [231, 76, 60],
        styles: {
            lineColor: 240,
            lineWidth: 0.1,
        },
        headStyles: {
            fillColor: [0, 60, 104],
            textColor: 240,
            fontSize: 8,
            fontStyle: 'bold',
            halign: 'center'
        },
        bodyStyles: {
            textColor: [0, 60, 104],
            fontSize: 9
        },
        columnStyles: getDCColumnStyle(),
        body: createDCJSONforPDF(),
        columns: getDCColumns(),
        didParseCell: data => {
            if (data.row.section === 'body' && _.includes(['datadashboard', 'distSchReportCard', 'distRawDataset'], data.column.dataKey)) {
                data.cell.text = '';
            }
        },
        didDrawCell: data => {
            if (data.row.section === 'body' && _.includes(['datadashboard', 'distSchReportCard', 'distRawDataset'], data.column.dataKey)) {
                if (data.cell.raw === true) {
                    let startPosition = data.cell.x + (data.cell.width / 2) - 2;
                    doc.addImage(chkImage, 'PNG', startPosition, data.cell.y + 2, 2.5, 2.5, 'chkImage');
                }
            }
        }
    });

    const yPosition = doc.autoTable.previous.finalY + 5;

    if (localStorage.getItem("academicyear") === 'currentyear' && reportOrderData.subscriptionEndDate) {
        // Display expiration note for the current year when subscriptionEndDate is available
        doc.setFontSize(9);
        doc.setTextColor(0, 0, 0);
        doc.text(margin, yPosition, `Note: Data Dashboard expires ${expDateToDisplay(reportOrderData.subscriptionEndDate, null)}`);
    } else {
        // Display generic note for historical year or when subscriptionEndDate is not available
        const note = "Note: The Data Dashboard column shows either the current or historical subscription status. For more information, contact your Technical Advisor.";
        
        // Split text into multiple lines to fit within page width
        const splitNote = doc.splitTextToSize(note, doc.internal.pageSize.width - margin * 2);
        
        doc.setFontSize(9);
        doc.setTextColor(0, 0, 0);
        doc.text(margin, yPosition, splitNote);
    }

    // School Reports Text
    doc.setFontSize(10);
    doc.setTextColor(143, 149, 151);
    doc.text(margin, doc.autoTable.previous.finalY + 20, 'SCHOOL REPORTS - Only checked items are included in your order');

    // Table for School Reports
    doc.autoTable({
        startY: doc.autoTable.previous.finalY + 23,
        margin: { left: margin, right: margin },  // Apply uniform margin to the second table
        tableLineColor: [231, 76, 60],
        styles: {
            lineColor: 240,
            lineWidth: 0.1,
        },
        headStyles: {
            fillColor: [0, 60, 104],
            textColor: 240,
            fontSize: 8,
            fontStyle: 'bold',
            halign: 'center'
        },
        bodyStyles: {
            textColor: [0, 60, 104],
            fontSize: 9
        },
        body: createJSONforPDF(),
        columnStyles: getColumnStyle(),
        columns: getColumns(),
        didParseCell: data => {
            if (data.row.section === 'body' && _.includes(['esCHKSrpt', 'esSCRCrpt', 'csCHKSrpt', 'csSCRCrpt', 'CSSSrpt', 'CSPSrpt'], data.column.dataKey)) {
                data.cell.text = "";
            }
        },
        didDrawCell: data => {
            if (data.row.section === 'body' && _.includes(['esCHKSrpt', 'esSCRCrpt', 'csCHKSrpt', 'csSCRCrpt', 'CSSSrpt', 'CSPSrpt'], data.column.dataKey)) {
                if (data.cell.raw === true) {
                    let startPosition = data.cell.x + (data.cell.width / 2) - 2;
                    doc.addImage(chkImage, 'PNG', startPosition, data.cell.y + 2, 2.5, 2.5, 'chkImage');
                }
            }
        }
    });

    // Save PDF with District Name
    try {
      const fileName = await pdfFileNameWithDist(urlDistName);
      if (fileName) {
          doc.save(fileName); 
      } else {
          console.error("File name generation failed.");
      }
    } catch (error) {
        console.error("Error generating or saving PDF: ", error);
    }    
  // doc.save(pdfFileNameWithDist(urlDistName));
};


  const expDateToDisplay = (dt, forFE) => {
    let output = null;
    if (dt) {
      let expDt = dt.split('-');
      if (forFE) {
        output = `Exp ${parseInt(expDt[1])}/${expDt[0].substring(2, 4)}`;
      } else {
        output = `${parseInt(expDt[1])}/${expDt[0].substring(2, 4)}`;
      }
    }
    return output;
  }

  const createJSONforPDF = () => {
    let output = [];
    CombinedSchoolrptdataFinal.map(survData => {
      survData.reportSchoolData.forEach(survDet => {
        output.push({
          'sn': survData.name.trim(),
          'sid': survData.ncesId,
          'esCHKSrpt': (survData.P1 == 1) ? true : false,
          'esSCRCrpt': '',
          'csCHKSrpt': (survData.P2 == 1) ? true : false,
          'csSCRCrpt': '',
          'CSSSrpt': (survData.P3 == 1) ? true : false,
          'CSPSrpt': (survData.P4 == 1) ? true : false,
        });
      });
    });
    let groupBySchNm = _.groupBy(output, 'sid');
    let finalObj = [];
    for (let x in groupBySchNm) {
      let distObj = {};
      distObj['sn'] = us.pluck(groupBySchNm[x], 'sn')[0];
      distObj['sid'] = us.pluck(groupBySchNm[x], 'sid')[0];
      distObj['esCHKSrpt'] = us.contains(us.pluck(groupBySchNm[x], 'esCHKSrpt'), true);
      distObj['esSCRCrpt'] = us.contains(us.pluck(groupBySchNm[x], 'esSCRCrpt'), true);
      distObj['csCHKSrpt'] = us.contains(us.pluck(groupBySchNm[x], 'csCHKSrpt'), true);
      distObj['csSCRCrpt'] = us.contains(us.pluck(groupBySchNm[x], 'csSCRCrpt'), true);
      distObj['CSSSrpt'] = us.contains(us.pluck(groupBySchNm[x], 'CSSSrpt'), true);
      distObj['CSPSrpt'] = us.contains(us.pluck(groupBySchNm[x], 'CSPSrpt'), true);
      finalObj.push(distObj);
    }
    return _.sortBy(finalObj, ({ sn }) => sn.toLowerCase());
  }

  const createDCJSONforPDF = () => {
    let output = [];

    reportOrderData.distReportData.map(survData => {
      let jsonObj = _.pick(survData, 'datadashboard', 'distSchReportCard', 'distRawDataset')
      jsonObj['datadashboard'] = reportOrderData.subscriptionEndDate ? true : false;
      jsonObj['distSchReportCard'] = survData.surveyName;
      jsonObj['distRawDataset'] = survData.distReportData[0].value == 1;
      jsonObj['surveyNm'] = survData.surveyName.replace("School Reports", "Survey");
      output.push(jsonObj);
    });
    return output;
  }

  const getDCColumnStyle = () => {
    let columns = ['datadashboard', 'distSchReportCard', 'distRawDataset'];
    let output = {};
    output['surveyNm'] = { cellWidth: '40' };
    columns.forEach(value => {
      output[value] = { cellWidth: '40' };
    });
    return output;
  }

  const getDCColumns = () => {
    let output = [];
    output.push({ header: 'All CalSCHLS Surveys', dataKey: 'surveyNm' });
    output.push({ header: 'Data Dashboard', dataKey: 'datadashboard' });
    output.push({ header: 'District Raw Dataset', dataKey: 'distRawDataset' });
    return output;
  }

  const getColumnStyle = () => {
    return {
      sn: { cellWidth: 75 },
      sid: { cellWidth: 31 },
      esCHKSrpt: { cellWidth: 24 },
      csCHKSrpt:  { cellWidth: 24 },
      CSSSrpt: { cellWidth: 22 },
      CSPSrpt: { cellWidth: 22 }
    };
  };

  const getColumns = () => {
    let output = [];
    output.push({ header: 'School Name', dataKey: 'sn' });
    output.push({ header: 'CDS Code', dataKey: 'sid' });
    output.push({ header: 'Elementary CHKS Report', dataKey: 'esCHKSrpt' });
    output.push({ header: 'Secondary CHKS Report', dataKey: 'csCHKSrpt' });
    output.push({ header: 'CSSS Report', dataKey: 'CSSSrpt' });
    output.push({ header: 'CSPS Report', dataKey: 'CSPSrpt' });
    return output;
  }

  const getAcademicYearFormatted = async () => {
    let academicYearId = localStorage.getItem("academicyear");
    let formattedYear;

    try {
        const response = await commonService.getAcademicYearById(academicYearId);
        if (response && response.academicYear) {
            const academicYear = response.academicYear.year;
            const startYear = academicYear.split('-')[0].slice(-2); // Get last two digits of the first year
            const endYear = academicYear.split('-')[1].slice(-2);
            formattedYear = startYear + endYear;
        } else {
            console.error("Academic year not found in the response.");
        }
    } catch (error) {
        console.error("Error fetching academic year:", error);
    }

    return formattedYear;
  };

  const pdfFileNameWithDist = async (urlDistName) => {
    let today = new Date();
    let formattedYear = await getAcademicYearFormatted();
    
    if (!formattedYear) {
      console.error("Formatted year not available.");
      return ""; 
    }
    console.log("formattedYear - report:", formattedYear);
  
    try {
      let dd = today.getDate();
      let mm = today.getMonth() + 1; //January is 0!
      let hoursMint = `${String(today.getHours()).padStart(2, '0')}${String(today.getMinutes()).padStart(2, '0')}`;

      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      today = `ReportOrder_${formattedYear}_${urlDistName.replace(/\s+|\\|\//g, "")}_${yyyy}${mm}${dd}${hoursMint}.pdf`;
    } catch (error) {
      console.log(`ERROR: ${error}, in pdfFileNameWithDist().`);
    }
    return today;
  }

  return (
    <>
      {(isLoading === true) ? <Spinner></Spinner> : ""}
      <div className='report_pageHeader'>
        <div className="report_pageText">Report Order Form</div>
        {reportOrderData.orderReportSubmit ?
          <div className='report_downloadPDF'>
            <div onClick={onreportpdfdownload} style={{ display: 'flex', justifyContent: 'end', cursor: 'pointer' }}>
              <img className='pdfImage' src={require('../../assets/images/downloadpdf_new.png')} alt='Download Pdf'></img>
            </div>
          </div>
          : ""}
      </div>
      {showPage ?
        <div className='report_pageContent'>
          <div className="report_dashboardDiv">
            {renderDataDashboardReports()}
          </div>
          <div className='report_reportDiv'>
            {(reportOrderData && reportOrderData.schoolReportData) ? renderSchoolReports() : ''}
          </div>
          <div className='report_reportDiv'>
            {(reportOrderData && reportOrderData.distReportData) ? renderDistrictReports() : ''}
            {!reportOrderData.orderReportSubmit && !isSaveButtShow ?
              <div className="orderReportNote blinkMe">
                <div> <img src={require('../../assets/images/impNote_new.png')} style={{ marginTop: '10px' }} /></div>
                <div style={{ 'marginLeft': '10px' }}>CalSCHLS will not receive your order until the SUBMIT ORDER button is clicked.</div>
              </div>
              : ''}
          </div>
          <div className="report_saveButtonSpace">
            {!reportOrderData.orderReportSubmit && isSaveButtShow && localStorage.getItem('academicyear') === 'currentyear' ?(
              <div className='report_saveButtonDiv'>
                <Button variant="contained" className='report_saveButton report_buttons' onClick={() => saveReport ("beforeSubmit")}>SAVE</Button>
              </div>
              ) : ''}

            {isSaveShowAdmin && localStorage.getItem('academicyear') === 'currentyear' ? (
            <div className='report_saveButtonDiv'>
              <Button variant="contained" className='report_saveButton report_buttons' onClick={() => saveReport("afterSubmit")} > SAVE BY ADMIN </Button>
            </div>
          ) : null}


            {!reportOrderData.orderReportSubmit && !isSaveButtShow ?
              <div className='report_saveButtonDiv'>
                <Button variant="contained" className='report_saveButton report_buttons' onClick={backClick}>GO BACK</Button>
              </div>
              : ''}
            <div className='report_saveButtonDiv'>
              {localStorage.getItem("academicyear") === 'currentyear' ? <Button variant="contained" className='report_submitButton report_buttons' onClick={goToCostEstimate}>COST ESTIMATES</Button> : ""}
            </div>
            {!reportOrderData.orderReportSubmit && localStorage.getItem("academicyear") === 'currentyear' ? (
            <div className='report_saveButtonDiv'>
              <Button variant="contained" className='report_buttons' 
              style={!isSaveButtShow ? { 'backgroundColor': '#1f9d24' } : { 'backgroundColor': '#eeeeee' }} disabled={isSaveButtShow ? true : false} 
              onClick={sumbitOrder} > SUBMIT ORDER </Button>
            </div>
          ) : null}


            {reportOrderData.subscriptionEndDate && localStorage.getItem("academicyear") === 'currentyear' ?
              <div className='report_saveButtonDiv'>
                <Button variant="contained" className='report_saveButton report_buttons' onClick={goToManageDashboard}>MANAGE DASHBOARD USERS</Button>
              </div>
              : ''}
          </div>
        </div>
        : ''}
    </>
  );
}

export default Report;